import { adminAuthApi } from "./api";

// GET: 상담신청서 사용자 리스트 조회
export const adminGetUserListForSurveyApi = (searchTerm) => adminAuthApi.get(`/survey/users?searchTerm=${searchTerm}`)

// GET: 상담신청서 내용 조회 by userId
export const adminGetSurveyFormApi = (userId) => adminAuthApi.get(`/survey/form/${userId}`)

// POST: 심리검사 코드 저장
export const adminSaveGuidanceCodeApi = (data) => adminAuthApi.post(`/survey/guidance/code`, data)

// POST: 심리검사 파일 업로드
export const adminUploadGuidanceFileApi = (formData) => adminAuthApi.post(
    `/survey/guidance/file`, formData, { headers: { "Content-Type": "multipart/form-data" } }
)

// DELETE: 심리검사 파일 삭제
export const adminDeleteGuidanceFileApi = (requestData) => adminAuthApi.post(`/survey/guidance/file/delete`, requestData)

// POST: 결과 보고서 저장
export const adminSaveReportApi = (formData, userId) => adminAuthApi.post(
    `/survey/report/${userId}`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } }
)

// GET: 결과 보고서 조회
export const adminGetReportApi = (userId) => adminAuthApi.get(`/survey/report/${userId}`)